/**
 * Formats a number to a string with thousand separators and decimal places
 */
const number = (options?: { decimalPlaces?: number; round?: boolean }) => (value: number | undefined) => {
  const { decimalPlaces = 0, round = false } = options || {};
  const numeric = Number(value);
  if (!numeric && numeric !== 0) {
    return '';
  } else {
    const rounded = round ? Math.round(numeric * (100 * (decimalPlaces + 1))) / (100 * (decimalPlaces + 1)) : numeric;
    const base = Math.trunc(rounded);
    const remainder = numeric.toLocaleString().split('.')[1] || '';
    const returnValue = `${base.toLocaleString()}.${remainder
      .substr(0, decimalPlaces)
      .padEnd(decimalPlaces, '0')}`.replace(/\.$/, '');
    return returnValue;
  }
};
/**
 * Formats a number to currency
 */
const currency = (options?: { currencyCode: 'USD' | 'CAD' }) => {
  const { currencyCode = 'USD' } = options || {};
  const amount = number({ decimalPlaces: 2, round: true });
  return currencyCode === 'USD' ? `$${amount}` : `$${amount} CAD`;
};

export const formatters = {
  number,
  currency
};
